<div class="receipt">
    <!-- Header -->
    <div class="header">
        <div class="company-name">
            <h1>PRID LIB</h1>
        </div>
        <div class="order-details">
            <h3>Order Details:</h3>
            <p><strong>Order Number:</strong> {{printData.orderNumber}}</p>
            <p><strong>Created:</strong> {{printData.orderDate}}</p>
            <p><strong>Status:</strong> {{printData.orderStatus}}</p>
        </div>
    </div>

    <!-- Sender and Receiver Information -->
    <div class="info">
        <div class="sender">
            <h3>Sender:</h3>
            <p><strong>Name:</strong> {{printData.senderName}}</p>
            <p><strong>Mobile:</strong> {{printData.senderPhone}}</p>
        </div>
        <div class="receiver">
            <h3>Receiver:</h3>
            <p><strong>Name:</strong> {{printData.recieverName}}</p>
            <p><strong>Mobile:</strong> {{printData.recieverPhone}}</p>
        </div>
    </div>

    <!-- Item List -->
    <div class="items">
        <table>
            <thead>
                <tr>
                    <th>Product Name</th>
                    <th>Qty</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody *ngFor="let items of printData.orderItems">
                <tr>
                    <td>{{items.productDisplayText}}</td>
                    <td>{{items.quantity}}</td>
                    <td>{{items.totalRetailPrice}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
